// eslint-disable-next-line no-restricted-imports
import moment from 'moment';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { enTranslation as enTranslationCcmsUi, esTranslation as esTranslationCcmsUi } from '@wonderschool/ccms-ui';
import {
  enTranslation as enTranslationBaseUi,
  esTranslation as esTranslationBaseUi,
} from '@wonderschool/common-base-ui';
import {
  enTranslation as enTranslationFoodProgram,
  esTranslation as esTranslationFoodProgram,
} from '@wonderschool/common-food-program-ui';
import { default as enWebTranslation } from './assets/locales/en/translation.json';
import { default as esWebTranslation } from './assets/locales/es/translation.json';
import { isLocal } from './config/env';

export const DEFAULT_LANGUAGE = 'en';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      ns: ['web', 'baseUi', 'ccms', 'foodProgram'],
      defaultNS: 'web',

      resources: {
        en: {
          web: { ...enWebTranslation },
          ccms: { ...enTranslationCcmsUi },
          baseUi: { ...enTranslationBaseUi },
          foodProgram: { ...enTranslationFoodProgram },
        },
        es: {
          web: { ...esWebTranslation },
          ccms: { ...esTranslationCcmsUi },
          baseUi: { ...esTranslationBaseUi },
          foodProgram: { ...esTranslationFoodProgram },
        },
      },

      fallbackLng: DEFAULT_LANGUAGE,
      debug: isLocal(),

      interpolation: {
        escapeValue: false,
      },

      parseMissingKeyHandler: (key) => {
        return key;
      },
    },
    () => {
      moment.locale(i18next.language);
    }
  );

export const changeLanguage = (lang: string) => {
  i18next.changeLanguage(lang);
  moment.locale(lang);
};

export default i18next;
